import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Table, Tag, Tooltip, Button, Popconfirm, Input, message, Spin, Drawer } from 'antd';
import { CloseCircleOutlined, FileAddOutlined, FormOutlined, MinusCircleOutlined } from '@ant-design/icons';
import Utils from '../../components/Utils';
import Globals from '../../config/Globals';

export default class CommonLicensesTable extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      sortedInfo: null,
      isDrawerVisible: false,
      currentLicense: null,
      notes: '',
      hoveredNotes: null,
    };
  }

  handleFilterChange(pagination, filters, sorter) {
    this.setState({ sortedInfo: sorter });
  }

  showEditDrawer(license) {
    this.setState({
      isDrawerVisible: true,
      currentLicense: license,
      notes: license.notes || '',
    });
  }

  handleDrawerOk() {
    const { currentLicense, notes } = this.state;
    this.handleLicenseNoteUpdate(currentLicense.id, notes);
    this.setState({ isDrawerVisible: false, currentLicense: null, notes: '' });
  }

  handleDrawerCancel() {
    this.setState({ isDrawerVisible: false, currentLicense: null, notes: '' });
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};

    const columns = [
      {
        title: 'Date',
        dataIndex: 'createdOn',
        key: 'createdOn',
        width: '10%',
        render: (createdOn) => (createdOn ? Utils.getDateOnUIFormatByTimestamp(createdOn) : '--'),
        sorter: (a, b) => a.createdOn - b.createdOn,
        sortOrder: sortedInfo.columnKey === 'createdOn' && sortedInfo.order,
      },
      // {
      //   title: 'License ID', dataIndex: 'id', key: 'id', width: '15%',
      //   sorter: (a, b) => a.id.localeCompare(b.id),
      //   sortOrder: sortedInfo.columnKey === 'id' && sortedInfo.order
      // },
      {
        title: 'Product',
        dataIndex: 'productName',
        key: 'productName',
        width: '15%',
        sorter: (a, b) => a.productName.localeCompare(b.productName),
        sortOrder: sortedInfo.columnKey === 'productName' && sortedInfo.order,
      },
      {
        title: 'License ID',
        dataIndex: 'id',
        key: 'id',
        width: '10%',
        sorter: (a, b) => a.id.localeCompare(b.id),
        sortOrder: sortedInfo.columnKey === 'id' && sortedInfo.order,
      },
      {
        title: 'Number of licenses',
        dataIndex: 'licNumber',
        key: 'licNumber',
        width: '8%',
        sorter: (a, b) => a.licNumber - b.licNumber,
        sortOrder: sortedInfo.columnKey === 'licNumber' && sortedInfo.order,
      },
      {
        title: 'Activations',
        dataIndex: 'licActivated',
        key: 'licActivated',
        width: '8%',
        sorter: (a, b) => a.licActivated - b.licActivated,
        sortOrder: sortedInfo.columnKey === 'licActivated' && sortedInfo.order,
      },
      {
        title: 'Assignments',
        dataIndex: 'assignCount',
        key: 'assignCount',
        width: '8%',
        sorter: (a, b) => a.assignCount - b.assignCount,
        sortOrder: sortedInfo.columnKey === 'assignCount' && sortedInfo.order,
      },
      {
        title: 'Reservations',
        dataIndex: 'reservedCount',
        key: 'reservedCount',
        width: '8%',
        sorter: (a, b) => a.assignCount - b.assignCount,
        sortOrder: sortedInfo.columnKey === 'assignCount' && sortedInfo.order,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: '8%',
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
        render: (status) => <Tag color={Globals.getColorByLicenseStatus(status)}>{status}</Tag>,
      },
      {
        title: 'Actions',
        width: '12%',
        key: 'Actions',
        render: (props) => {
          const remainingActivations =
            props.licNumber - (props.licActivated + (props.assignCount || 0) + (props.reservedCount || 0));
          return (
            <span className="tableButtonContainer">
              {this.props.isAdmin && props.status != Globals.License_State.REVOKED && (
                <Tooltip placement="bottomLeft" title="Revoke">
                  <Popconfirm
                    placement="top"
                    title="Are you sure that you want to revoke this license?"
                    onConfirm={() => this.props.onRevoke(props)}
                    okText="Yes"
                    cancelText="No"
                    disabled={props.status == Globals.License_State.REVOKED}
                  >
                    <Button
                      variant="none"
                      icon={<CloseCircleOutlined />}
                      shape="circle"
                      disabled={props.status == Globals.License_State.REVOKED}
                    />
                  </Popconfirm>
                </Tooltip>
              )}
              {this.props.isAdmin && remainingActivations > 0 && props.status == Globals.License_State.ACTIVE && (
                <Tooltip placement="bottomLeft" title="Revoke one activation">
                  <Popconfirm
                    placement="top"
                    title="Confirm revocation of an activation for this license?"
                    onConfirm={() => this.revokeLicenseActivations(props.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      variant="none"
                      icon={<MinusCircleOutlined />}
                      shape="circle"
                      style={{ marginLeft: '8px' }}
                    />
                  </Popconfirm>
                </Tooltip>
              )}
              {props.licNumber > props.licActivated + (props.assignCount || 0) + (props.reservedCount || 0) &&
                !props.isAssignment &&
                props.status == Globals.License_State.ACTIVE &&
                (this.props.isAdmin || this.props.isOrgManager) && (
                  <Tooltip placement="bottomLeft" title="Assign License">
                    <Button
                      variant="none"
                      icon={<FileAddOutlined />}
                      shape="circle"
                      style={{ marginLeft: '8px' }}
                      onClick={() => this.props.onAssign(props)}
                    />
                  </Tooltip>
                )}
              {this.props.isAdmin && (
                <Tooltip placement="bottomLeft" title="Edit Notes">
                  <Button
                    variant="none"
                    icon={<FormOutlined />}
                    shape="circle"
                    onClick={() => this.showEditDrawer(props)}
                    style={{ marginLeft: '8px' }}
                  />
                </Tooltip>
              )}
            </span>
          );
        },
      },
    ];

    const props = {
      rowKey: 'id',
      loading: this.props.isLoading,
      onChange: this.handleFilterChange,
      locale: { emptyText: 'No licenses found!' },
      pagination: {
        pageSize: Globals.Table_PagingItemsPerPage,
        hideOnSinglePage: true,
        showSizeChanger: false,
        position: ['bottomCenter'],
      },
    };

    return (
      <>
        {this._renderNotesDrawer()}
        <Tooltip position="top" title={this.state.hoveredNotes} visible={!!this.state.hoveredNotes}>
          <Table
            className="adminSearchUsersTable"
            onRow={this._onRow}
            columns={columns}
            dataSource={this.props.licenses}
            scroll={{ x: true }}
            sticky
            {...props}
          />
        </Tooltip>
      </>
    );
  }

  _onRow(record) {
    return {
      onClick: (e) => {
        const elementsToPreventClick = ['svg', 'path', 'button', 'span'];
        if (elementsToPreventClick.includes(e.target.tagName.toLowerCase())) return;
        if (this.props.onSelectRow) this.props.onSelectRow(record);
      },
      onDoubleClick: (e) => {
        const elementsToPreventClick = ['svg', 'path', 'button'];
        if (elementsToPreventClick.includes(e.target.tagName.toLowerCase())) return;
        if (this.props.onSelectRow) this.props.onSelectRow(record);
      },
      onMouseEnter: () => this.setState({ hoveredNotes: record.notes }),
      onMouseLeave: () => this.setState({ hoveredNotes: null }),
    };
  }

  _renderNotesDrawer() {
    return (
      <Drawer
        width={400}
        title="Edit Notes"
        open={this.state.isDrawerVisible}
        onClose={() => this.handleDrawerCancel()}
        footer={
          <>
            <Button style={{ marginRight: 4 }} type="primary" onClick={() => this.handleDrawerOk()}>
              Save
            </Button>
            <Button type="secondary" onClick={() => this.handleDrawerCancel()}>
              Cancel
            </Button>
          </>
        }
      >
        <Input.TextArea value={this.state.notes} onChange={(e) => this.setState({ notes: e.target.value })} />
      </Drawer>
    );
  }

  //API
  async handleLicenseNoteUpdate(licenseId, notes) {
    const resp = await this.props.app.license.license.updateLicenseByID(licenseId, { notes });

    if (resp.statusCode === 200) {
      message.success('Note updated successfully!');
      await this.props.reloadTable();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
  }

  async revokeLicenseActivations(licenseId) {
    const resp = await this.props.app.license.license.revokeLicenseActivations(licenseId, 1);

    if (resp.statusCode === 200) {
      message.success('Activation revoked successfully!');
      await this.props.reloadTable();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
  }
}
